
/*
 * Filename: store-manager.ts
 * Description: Component for store manager.
 */

import { CQMasterDataStore } from "./cq-master-data.store";

export class CQStoreManager {

    /**
     * @param {*} deployedTemplate
     * @memberof CQStoreManager
     */
    public storeDeployedTemplate(deployedTemplate: any) {
        
        this.setOutputConfig(deployedTemplate, deployedTemplate.template);
        this.setRuleElements(deployedTemplate);
        this.setDeployedInputRules(deployedTemplate);
        this.setDeployedDynamicSource(deployedTemplate);
        this.setDeployedPicklistData(deployedTemplate);
        this.setDeployedUITypeData(deployedTemplate);
        this.setDeployedFormulaField(deployedTemplate);
    }

    private setRuleElements(deployedTemplate: any) {
        if (deployedTemplate.hasOwnProperty('ruleElements')) {
            CQMasterDataStore.RuleElements.setRuleElements(deployedTemplate.ruleElements);
        }
    }

    private setOutputConfig(deployedTemplate: any, templateName: string) {
        CQMasterDataStore.OutputConfig.setTemplateObject(templateName, deployedTemplate);
    }

    /**
     * @param {*} inputRules
     * @memberof CQStoreManager
     */
    public setDeployedInputRules(deployedTemplate: any) {
        if (deployedTemplate.hasOwnProperty('inputRules')) {
            CQMasterDataStore.RulesObject.setInputRulesObject(deployedTemplate.inputRules);
        }
    }

    /**
     * @param {*} dynamicSource
     * @param {*} lookupFilter
     * @memberof CQStoreManager
     */
    public setDeployedDynamicSource(deployedTemplate: any) {

        if (deployedTemplate.hasOwnProperty('dynamicSource')) {
            let dynamicSource = deployedTemplate.dynamicSource;
            let lookupFilter = deployedTemplate.hasOwnProperty('lookupFilter') ? deployedTemplate.lookupFilter : {}
            let dynamicSourceObject = {};
            Object.keys(dynamicSource).forEach((objectKey: string) => {
                if (lookupFilter.hasOwnProperty === objectKey) {
                    let dsObject = {
                        [objectKey]: {
                            DynamicSource: dynamicSource[objectKey],
                            LookupFilter: lookupFilter[objectKey]
                        }
                    }
                    dynamicSourceObject = { ...dynamicSourceObject, dsObject }
                } else {
                    let dsObject = {
                        [objectKey]: {
                            DynamicSource: dynamicSource[objectKey]
                        }
                    }
                    dynamicSourceObject = { ...dynamicSourceObject, ...dsObject }
                }
            });
            
            CQMasterDataStore.DynamicSourceValue.setDeployedDynamicSource(dynamicSourceObject);
        }

    } 

    /**
     * @param {*} picklistValueSource
     * @memberof CQStoreManager
     */
    public setDeployedPicklistData(deployedTemplate: any) {
        if (deployedTemplate.hasOwnProperty('picklistValueSource')) {
            
            CQMasterDataStore.PicklistValueSource.setDeployedPicklistData(deployedTemplate.picklistValueSource);
        }

    }

    /**
     * @param {*} uiTypeValueSource
     * @memberof CQStoreManager
     */
    public setDeployedUITypeData(deployedTemplate: any) {
        if (deployedTemplate.hasOwnProperty('uiTypeValueSource')) {
            
            CQMasterDataStore.UITypeSource.setDeployedUITypeData(deployedTemplate.uiTypeValueSource);
        }

    }

    /**
     * @param {*} fornulaFieldValue
     * @memberof CQStoreManager
     */
    public setDeployedFormulaField(deployedTemplate: any) {
        if (deployedTemplate.hasOwnProperty('formulaFields')) {
            
            //   CQMasterDataStore.FormulaField.selectedFormulaFieldValue(deployedTemplate.formulaFields);
        }

    }

    /**
     * @param {*} inputRules
     * @memberof CQStoreManager
     */
    public setInputRules(inputRules: any) {
        
    }

    /**
     * @param {*} picklistValueSource
     * @memberof CQStoreManager
     */
    public setPicklistData(picklistValueSource: any) {
        
    }

    /**
     * @param {*} dynamicSource
     * @memberof CQStoreManager
     */
    public setDynamicSource(dynamicSource: any) {
        
    }

    /**
     * @param {*} formulaField
     * @memberof CQStoreManager
     */
    public formulaaField(formulaField: any) {
        
    }
}

